<script>
    export let model;

    import Name from "../Name.svelte";
    import ProfilePicture from "../ProfilePicture.svelte";
    import ContributorModel from "../../models/participaid/Contributor.js";
</script>

<span class="contributor-inline">
    {#if model}
        <ProfilePicture user={model.user} style="max-width: 32px;" shadow={false}/>
        <Name model={model.user} strong/>
    {:else}
        ...
    {/if}
</span>

<style>
    .contributor-inline {
        display: inline-flex;
        align-items: center;
        flex-direction: row;

        /* TODO: refactor project title tag into container */
        //background: #D3EFFF;

        color: #333;
        padding: 4px 4px;
        font-weight: 500;
        margin: 0 2px;

        /*-webkit-box-shadow: 1px 1px 19px -8px rgba(0,0,0,0.75);
        -moz-box-shadow: 1px 1px 19px -8px rgba(0,0,0,0.75);
        box-shadow: 1px 1px 19px -8px rgba(0,0,0,0.75);*/
    }
</style>